// Footer.jsx
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
  faInstagram, 
  faWhatsapp, 
  faFacebook, 
  faTwitter,
  faYoutube 
} from '@fortawesome/free-brands-svg-icons'
import { 
  faPhone, 
  faEnvelope, 
  faLocationDot,
  faClock,
  faCalendarCheck,
  faTicket,
  faStore,
  faArrowRight,
  faCrown,
  faUtensils,
  faMusic
} from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="simple-footer">
      {/* Simple Top Border */}
      <div className="simple-top-border"></div>
      
      {/* Main Footer Content */}
      <div className="simple-footer-main">
        <div className="container">
          <div className="row g-4">
            
            {/* Brand Column */}
            <div className="col-lg-4 col-md-6">
              <div className="simple-brand">
                <h3 className="simple-logo">
                  ROYAL HERITAGE FIESTA
                </h3>
                <p className="simple-tagline">Where Legacy Meets Celebration</p>
                <p className="simple-description">
                  Creating unforgettable royal experiences that blend tradition with modern elegance. 
                  Your trusted partner for extraordinary celebrations since 2015.
                </p>
                <div className="simple-social">
                  <a href="https://www.facebook.com/royaleheritagefiesta" className="simple-social-link facebook" aria-label="Facebook">
                    <FontAwesomeIcon icon={faFacebook} />
                  </a>
                  <a href="https://www.instagram.com/royaleheritagefiesta?igsh=MTM3dG8xYm43bXpoaQ==" className="simple-social-link instagram" aria-label="Instagram">
                    <FontAwesomeIcon icon={faInstagram} />
                  </a>
                  <a href="https://wa.link/e7iqhp" className="simple-social-link whatsapp" aria-label="WhatsApp">
                    <FontAwesomeIcon icon={faWhatsapp} />
                  </a>
                  <a href="https://www.youtube.com/@royaleheritagefiesta" className="simple-social-link youtube" aria-label="YouTube">
                    <FontAwesomeIcon icon={faYoutube} />
                  </a>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-6">
              <h5 className="simple-footer-heading">Quick Links</h5>
              <ul className="simple-footer-links">
                <li><Link to="/" onClick={scrollToTop}>Home</Link></li>
                <li><Link to="/eventcalander_2" onClick={scrollToTop}>Events Calendar</Link></li>
                <li><Link to="/AboutUs" onClick={scrollToTop}>About Us</Link></li>
                <li><Link to="/ContactUs" onClick={scrollToTop}>Contact Us</Link></li>
              </ul>
            </div>

            {/* Our Services */}
            <div className="col-lg-3 col-md-6">
              <h5 className="simple-footer-heading">Our Services</h5>
              <ul className="simple-services-list">
                <li>
                  <FontAwesomeIcon icon={faCrown} className="simple-service-icon" />
                  <span>Royal Heritage Fiesta</span>
                </li>
                <li>
                  <FontAwesomeIcon icon={faUtensils} className="simple-service-icon" />
                  <span>Royal Dinners</span>
                </li>
                <li>
                  <FontAwesomeIcon icon={faMusic} className="simple-service-icon" />
                  <span>Music & Concerts</span>
                </li>
                <li>
                  <FontAwesomeIcon icon={faStore} className="simple-service-icon" />
                  <span>Stall Booking</span>
                </li>
                <li>
                  <FontAwesomeIcon icon={faTicket} className="simple-service-icon" />
                  <span>Ticket Booking</span>
                </li>
                <li>
                  <FontAwesomeIcon icon={faCalendarCheck} className="simple-service-icon" />
                  <span>Event Planning</span>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="col-lg-3 col-md-6">
              <h5 className="simple-footer-heading">Contact Info</h5>
              <ul className="simple-contact-list">
                <li>
                  <div className="simple-contact-icon">
                    <FontAwesomeIcon icon={faPhone} />
                  </div>
                  <div className="simple-contact-details">
                    <span className="simple-contact-label">Sales & Support</span>
                    <a href="tel:+919966252374" className="simple-contact-value">+91 99662 52374</a>
                  </div>
                </li>
                <li>
                  <div className="simple-contact-icon">
                    <FontAwesomeIcon icon={faPhone} />
                  </div>
                  <div className="simple-contact-details">
                    <span className="simple-contact-label">Emergency</span>
                    <a href="tel:+919396536350" className="simple-contact-value">+91 99662 52374</a>
                  </div>
                </li>
                <li>
                  <div className="simple-contact-icon">
                    <FontAwesomeIcon icon={faEnvelope} />
                  </div>
                  <div className="simple-contact-details">
                    <span className="simple-contact-label">Email Us</span>
                    <a href="mailto:royalheritagefiesta@gmail.com" className="simple-contact-value">royalheritagefiesta@gmail.com</a>
                  </div>
                </li>
                <li>
                  <div className="simple-contact-icon">
                    <FontAwesomeIcon icon={faLocationDot} />
                  </div>
                  <div className="simple-contact-details">
                    <span className="simple-contact-label">Visit Us</span>
                    <span className="simple-contact-value">Road No. 2, Durgam Cheruvu<br />Hyderabad - 500032</span>
                  </div>
                </li>
                <li>
                  <div className="simple-contact-icon">
                    <FontAwesomeIcon icon={faClock} />
                  </div>
                  <div className="simple-contact-details">
                    <span className="simple-contact-label">Office Hours</span>
                    <span className="simple-contact-value">Mon-Sat: 9:00 AM - 7:00 PM</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="simple-copyright">
        <div className="container">
          <div className="simple-copyright-content">
            <p style={{
              fontSize: '0.8rem',
              color: '#f7f0f0',
              margin: 0
            }}>
              © {currentYear} Royal Heritage Fiesta. All rights reserved. Developed By{' '}
              <a 
                href="https://mediawagon.in/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="mediawagon-link"
              >
                Media Wagon
              </a>
            </p>
            <div className="simple-copyright-links">
              <Link to="/privacy">Privacy Policy</Link>
              <span className="simple-separator">|</span>
              <Link to="/terms">Terms of Use</Link>
              <span className="simple-separator">|</span>
              <Link to="/refund">No Refund Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer